module.exports = __webpack_public_path__ + "static/media/moog.aea484ff.png";